import styled from 'styled-components';

import { MdsTypography } from '@/shared/ui/mds';

export const UIGiftDetail = ({ content }: { content: string }) => {
  if (!content?.trim()) return null;

  return (
    <S.Container>
      <MdsTypography
        variant="body13pxReg"
        colorScheme="gray-600"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    padding: 12px 16px;
  `,
};
